<template>
  <div class="hall-wrap">
    <action-bar class="head-bar" :lottery_type="category_id">
      <div class="left" slot="left">
        <button data-list="1">彩种切换</button>
      </div>

      <div class="title" slot="title">
        <span>{{ curSupText }}</span>-
        <span>{{ curSubText }}</span>
        <button data-list="2"></button>
      </div>
    </action-bar>

    <main class="main" ref="main">
      <!-- 彩种切换的list -->
      <transition name="list">
        <hall-hide-list
          class="list sup-list"
          v-show="ListStatus === 1"
          @onItemClick="handleSupClick"
          :list="supTabs"
        ></hall-hide-list>
      </transition>

      <!-- 中间的list -->
      <transition name="list">
        <hall-hide-list
          class="list sub-list"
          v-show="ListStatus === 2"
          @onItemClick="handleSubClick"
          :type="2"
          :list="subTabs"
        ></hall-hide-list>
      </transition>

      <!-- 中奖号码 -->
      <award-nums
        v-if="curLottery"
        :stage="stage"
        :type="sup"
        :numbers="numbers"
        :shengxiao="shengxiao"
        :lottery_type="category_id"
        :islhLm="islhLm"
      ></award-nums>

      <!-- 各项倒计时 -->
      <count-wrap :nextLottery="nextLottery" :lottery_type="category_id" ref="c1"></count-wrap>
      <TabSwiperLH
        ref="tabSwiperRef"
        :class="['lmnum'+category_id]"
        v-if="islhLm"
        :data="typeBalls"
        :subId="sub"
        :suPId="sup"
        :category_id="category_id"
        :shengxiaoData="lhShengxiaoData"
        :nextLottery="nextLottery"
        @selectedlm="selectedlmLH"
        @getItem="getItem"
      />
      <TabSwiper
        :class="['lmnum'+category_id]"
        v-else-if="islm"
        :data="typeBalls"
        @selectedlm="selectedlm"
      />

      <section
        :key="'bl' + gindex"
        v-for="(ballOb, gindex) in typeBalls"
        class="ballList-wrap"
        v-else
      >
        <!-- 如果号码要用图片显示下面type的值为"sub",并且se-ball用备份那个文件 -->
        <h3 class="testh3">{{ ballOb.group }}</h3>
        <div class="ball-list">
          <se-ball
            @selected="selected"
            class="ball"
            :key="i.odds_tpl_id"
            :type="1"
            :lottery_type="category_id"
            v-for="(i,index) in ballOb.data"
            :item="i"
            :index="index"
            :gindex="gindex"
            :nextLottery="nextLottery"
          ></se-ball>
        </div>
      </section>
    </main>

    <car-wrap class="car" @sendBat="sendBat" @clear="clear" :selectData="selectData" :results="results"
              :islhLm="islhLm"
    ></car-wrap>
  </div>
</template>

<script>
import { MiniHorn, MiniHornItem } from "mini-horn";
import ActionBar from "@/components/action-bar";
import HallHideList from "@/components/b-menu-list";
import SeBall from "@/components/se-ball";
import AwardNums from "./components/award-nums";
import CountWrap from "./components/count-wrap";
import CarWrap from "./components/car-wrap";
import TabSwiper from "./components/tab-swiper";
import TabSwiperLH from "./components/tab-swiper-lh";

import Vue from "../../../utils/bus"

import {
  getLotteryTypes,
  getLotteryLatest,
  getLotteryChildData,
  getNewLotteryRes,
  getOddsData,
  createLotteryOrder,
  getShengxiao
} from "@/service/lottery";
import { mapActions, mapState } from "vuex";
import objectPath from 'object-path';
import { generateShengxiaoLianmaData, lhComputedLm, lhCurrentTabLength } from "../../../utils/lhMethods";
import { getTabItem } from "../../../utils/lhConfig";

export default {
  name: "v-hall",
  components: {
    MiniHornItem,
    HallHideList,
    AwardNums,
    MiniHorn,
    ActionBar,
    CountWrap,
    CarWrap,
    SeBall,
    TabSwiper,
    TabSwiperLH
  },
  data() {
    return {
      islm: false,

      sup: 1,
      sub: 1,
      category_id: 0, //lottery_type
      ListStatus: 0,
      supTabs: [],
      subTabs: [],
      curSubText: "",
      curSupText: "",
      curLottery: null,
      nextLottery: null,
      numbers: [], //中奖号码
      shengxiao: [], //中奖生肖
      stage: "",
      nexStage: "",
      typeBalls: [],
      dataselect: [],
      results: [],
      money: 0,
      batData: [],
      islhLm: false,  // 六合
      lhShengxiaoData: [],
      selectData: [],
      lhPlayedName: '', // 六合子玩法name
    };
  },

  async created() {
    let query = this.$route.query;

    let types = await getLotteryTypes();
    let supTabs = types.data;
    this.supTabs = supTabs.map(item => {
      item.value = item.id;
      item.title = item.lottery_name;
      item.path = "";
      return item;
    });
    let supTab = this.supTabs[0];
    if (query.lottery_type) {
      supTabs.forEach(element => {
        if (element.lottery_type == query.lottery_type) {
          supTab = element;
        }
      });
    }
    this.getHeadres(supTab.lottery_type);
    this.category_id = supTab.id;
    this.getSubs(supTab.category);
    this.sup = supTab.category;
    this.getItem(supTab.category, this.sub, this.category_id);
    this.curSupText = supTab.title;
  },

  computed: {
    ...mapState({
      selectedDantuoData: state => state.root.selectedDantuoData,
      selectedShengxiaoPlayRadio: state => state.root.selectedShengxiaoPlayRadio
    }),
    ballType() {
      let {sub, sup} = this;
      let _type = 1;
      if (sup === 1) {
        _type = sub === 3 ? 2 : sub;
      } else {
        _type = sup;
      }
      return _type;
    }
  },

  methods: {
    ...mapActions("root", ["getLotteryLongQueue"]),
    async getHeadres(lottery_type) {
      let res = await getNewLotteryRes({sub_category_id: this.sub, lottery_type: lottery_type || this.category_id});
      this.curLottery = res.data.latest_result;
      this.numbers = this.curLottery.number.split(",");
      this.shengxiao = this.curLottery.shengxiao.split(",");
      this.stage = this.curLottery.period;
      this.nextLottery = res.data.next_info;
      // 发起长龙
      this.getLotteryLongQueue({lottery_type: this.category_id});
      // 发起生肖,如果存在，不再进行请求了
      if (this.lhShengxiaoData.length === 0) {
        const shengxiaoRef = await getShengxiao();
        if (shengxiaoRef.result === 'ok') {
          this.lhShengxiaoData = shengxiaoRef.data
        }
      }
    },
    //OLD
    combine(arr, num) {
      const r = [];
      (function f(t, a, n) {
        if (n == 0) {
          return r.push(t);
        }
        for (let i = 0, l = a.length; i <= l - n; i++) {
          f(t.concat(a[i]), a.slice(i + 1), n - 1);
        }
      })([], arr, num);
      return r;
    },
    selectedlm(selectItem) {
      //console.log('selectItem', selectItem);
      let item = objectPath.get(this.typeBalls, `0.data.${selectItem.selectedId}`);
      let itemArr = [];
      let resutArr = [];
      let betArr = [];
      let newArr = [];
      selectItem.selectedCount.forEach((it, index) => {
        if (it) {
          itemArr.push(index);
        }
      });
      if (item.class3 == "任选二" || item.class3 == "选二连直" || item.class3 == "选二连组") {
        newArr = this.combine(itemArr, 2);
      } else if (item.class3 == "任选三" || item.class3 == "选三前组") {
        newArr = this.combine(itemArr, 3);
      } else if (item.class3 == "任选四") {
        newArr = this.combine(itemArr, 4);
      } else if (item.class3 == "任选五") {
        newArr = this.combine(itemArr, 5);
      }
      newArr.forEach((i, j) => {
        resutArr.push({
          content: item.class3 + ":" + i.join(","),
          odds: item.odds,
          class3: itemArr.join(","),
          class4: i.join(",")
        });
        betArr.push({
          class1: item.class1,
          class2: item.class2,
          class3: itemArr.join(","),
          class4: i.join(","),
          odds: item.odds,
          id: item.id,
          odds_tpl_id: item.odds_tpl_id,
          played_name: item.played_name,
          status: item.status
        });
      });
      this.batData = betArr;
      this.results = resutArr;
    },
    // 六合
    selectedlmLH(record) {
      const {selectedCount} = record;
      const selectedCountData = Object.keys(selectedCount);
      // 还原
      if (selectedCountData.length === 0) {
        this.onLhReset();
        return;
      }
      // 初期写项目的人数据存放特别乱，在前人的基础上只能做优化，filterSelect是为做处理的数据数组，在下单时判断买了几个号码。newBatData是经过处理的数据（传给后台的）.resultData弹框展示用的数据
      let filterSelect = [];
      let newBatData = [];
      let resultData = [];
      selectedCountData.forEach((key) => {
        if (selectedCount[key]) {
          filterSelect.push(selectedCount[key]);
        }
      });
      const subTabLabel = objectPath.get(this.subTabs, `${this.sub - 1}.label`);
      // 六合特殊玩法，这些需要特殊处理，最少要选择两个以上才进入判断
      if (
        (
          (this.sub === 6 && subTabLabel === '连肖') ||
          (this.sub === 7 && subTabLabel === '连尾') ||
          (this.sub === 8 && subTabLabel === '连码') ||
          (this.sub === 9 && subTabLabel === '自选不中') ||
          (this.sub === 11 && subTabLabel === '合肖') ||
          (this.sub === 12 && subTabLabel === '特平中') ||
          (this.sub === 13 && subTabLabel === '中一')
        )
      ) {
        newBatData = lhComputedLm(filterSelect, this.selectedShengxiaoPlayRadio, this.selectedDantuoData) || filterSelect;
      } else {
        newBatData = filterSelect;
      }
      // 转换下单弹框数据
      newBatData.forEach((item) => {
        resultData.push({
          content: item.class4 || item.class3,
          odds: item.odds,
          class3: item.class3,
          class4: item.class4
        });
      });
      this.selectData = filterSelect;
      this.batData = newBatData;
      this.results = resultData;
    },
    // 投注
    sendBat(money) {
      let batData = this.batData.map(item => {
        item.money = parseFloat(money);
        return item;
      });
      createLotteryOrder({
        category_id: this.sup,
        sub_category_id: this.sub,
        lottery_type: this.category_id,
        period: this.nextLottery.period,
        //data: [batData[0]]
        data: batData
      }).then(res => {
        if (res.result === "ok") {
          this.clear();
          this.$refs.c1.getUser();
          this.$toast.center("投注成功");
          //Vue.$emit('reseTabSwiper');//OLD
          Vue.$emit('removeMoney');//OLD
          //this.onLhRefReset();
        } else {
          this.$toast.center(res.msg);
        }
      });
    },
    async handleSupClick(sup) {
      this.ListStatus = 0;
      this.sup = sup.category;
      this.category_id = sup.id;
      this.getHeadres(sup.lottery_type);
      this.curSupText = sup.title;
      this.getSubs(sup.category);
      this.islm = false;
      this.islhLm = false;
      this.getItem(sup.category, 1, this.category_id);
      this.clear();
      this.onLhRefReset();
    },

    //清理日志
    clear() {
      // 六合重置
      if (this.islhLm && this.$refs.tabSwiperRef) {
        this.$refs.tabSwiperRef.resetData();
      }
      if (this.sub == 12 && this.sup == 1) {
        //再考虑
      } else {
        this.typeBalls = this.typeBalls.map(item => {
          if (Array.isArray(item.data)) {
            item.data = item.data.map(d => {
              d.selected = false;
              return d;
            });
          }
          return item;
        });
      }
      this.results = [];
    },

    selected(item, gindex, index) {
      this.typeBalls[gindex].data[index].selected = !this.typeBalls[gindex]
        .data[index].selected;
      let results = [];
      let batData = [];
      this.typeBalls.forEach(group => {
        group.data.forEach(item => {
          if (item.selected) {
            batData.push(item);
            results.push({
              content: item.class2 + ":" + item.class3,
              odds: item.odds,
              id: gindex + "_" + index
            });
          }
        });
      });
      this.batData = batData;
      this.results = results;
    },
    async getSubs(id) {
      let childData = await getLotteryChildData(id);
      let subTabs = childData.data;
      this.subTabs = subTabs.map(item => {
        item.value = item.sub_category_id;
        item.title = item.sub_category_name;
        return item;
      });
      this.sub = this.subTabs[0].value;
      this.curSubText = this.subTabs[0].title;
    },
    // 获取赔率
    getItem(category_id = this.sup, sub_category_id = this.sub, lottery_type = this.category_id, name = this.lhPlayedName) {
      //console.log(category_id, sub_category_id, lottery_type);
      // 判断 代开lh菜单
      if (category_id === 4) {
        this.islhLm = true;
      }
      let playedItem = getTabItem(this.sub);
      let newName = name ? name : (playedItem.length > 0 && playedItem[0] || '');
      getOddsData({
        category_id,
        sub_category_id,
        lottery_type,
        played_name: newName
      }).then(res => {
        if (res.result === "ok") {
          this.typeBalls = res.data.map(item => {
            item.data = item.data.map(element => {
              element.selected = false;
              return element;
            });
            return item;
          });
          // 如果是连码，需要对原数据做特别的处理、分类
          if (sub_category_id === 8) {
            this.typeBalls = generateShengxiaoLianmaData(this.typeBalls, this.lhShengxiaoData);
          }
        }
      });
    },
    // 调用子集ref的清理
    onLhRefReset() {
      // 只有在六合的情况下才清空
      if (this.islhLm && this.$refs.tabSwiperRef) {
        this.$refs.tabSwiperRef.resetData();
        this.$refs.tabSwiperRef.resetRender();
      }
      this.onLhReset();
    },
    //  清理本组件中，涉及到六合的数据
    onLhReset() {
      this.ListStatus = 0;
      this.$refs.main.scrollTo(0, 0);
      this.results = [];
      this.batData = [];
      this.selectData = [];
    },
    handleSubClick(sub) {
      this.onLhRefReset();

      if (sub.sub_category_id == 12 && this.sup == 1) {
        this.islm = true;
      } else {
        this.islm = false;
      }
      this.sub = sub.sub_category_id;
      this.curSubText = sub.title;
      this.getItem(this.sup, sub.sub_category_id, this.category_id);
      this.clear();
    },

    showList(e, type) {
      const {list} = e.target.dataset;
      this.ListStatus = this.ListStatus == list ? 0 : Number(list || 0);
    }
  },

  mounted() {
    document.addEventListener("click", this.showList);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.showList);
  }
};
</script>

<style scoped lang="less">
.hall-wrap {
  display: flex;
  position: relative;
  background: #ededed;
  flex-direction: column;

  .head-bar {
    z-index: 100;
    position: relative;
    flex-shrink: 0;

    .left,
    .right {
      width: 140px;

      > button {
        height: 60px;
      }
    }

    .title {
      display: flex;
      text-align: center;
      align-items: center;
      font-weight: bold;
      justify-content: center;

      > button {
        width: 50px;
        height: 50px;
        border: 1px solid #b40f06;
        position: relative;
        margin-left: 10px;
        border-radius: 25px;

        &:after {
          top: 22px;
          left: 13px;
          display: block;
          content: "";
          position: absolute;
          border-top: 10px solid #fff;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-bottom: none;
          transition: transform 0.2s linear;
        }
      }
    }

    .right {
      text-align: right;

      > button {
        padding: 0 18px;
        font-size: 44px;
      }
    }

    button {
      color: #fff;
      border: 1px solid #b70a00;
      padding: 0 16px;
      position: relative;
      font-size: 24px;
      background: #e8291d;
      background: -webkit-gradient(linear,
      0 0,
      0 70%,
      from(#f94539),
      to(#e8291d));
      box-shadow: 0 2px 2px #fc7f77 inset;
      border-radius: 10px;
    }
  }

  .main {
    flex: 1;
    overflow-x: hidden;
    overflow-y: auto;

    .list {
      top: 90px;
      position: absolute;

      &.sup-list {
        left: 0px;

        &:after {
          left: 60px;
        }
      }

      &.sub-list {
        left: 50%;
        margin-left: -300px;
      }

      &.menu-list {
        right: 0px;

        &:after {
          left: 160px;
        }
      }
    }
  }

  .car {
    height: 160px;
  }

  .ballList-wrap {
    padding-right: 20px;
    border-bottom: 1px solid #dadada;

    h3 {
      color: #e32116;
      padding: 20px;
      font-size: 24px;
      font-weight: bold;
      padding-bottom: 0;
    }

    .ball-list {
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 10px;

      .ball {
        margin-top: 10px;
        margin-left: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/hall/index.vue